import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await apiClient.post("/auth/session", {
          session_id: sessionId,
        });
        // Clear hash and hydrate auth context BEFORE navigating
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data.user);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("Auth callback error", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="flex items-center gap-2 text-zinc-600">
        <div className="w-5 h-5 border-2 border-[#FF4500] border-t-transparent rounded-full animate-spin" />
        <span className="font-mono text-sm">Signing you in…</span>
      </div>
    </div>
  );
}
